import { API_RESOURCE } from '@/constants/api.constant'
import { axios } from '@/lib/axios'
class OfferApprovalService {
  constructor() {
    this.resource = API_RESOURCE.OFFER
  }

  //Submit
  submitOfferQuotation = async ({ id, data }) => {
    const response = await axios.put(`${this.resource}/${id}/submitQuotation`, data)

    return response.data
  }

  submitOfferBooking = async ({ id }) => {
    const response = await axios.put(`${this.resource}/${id}/submitBooking`)

    return response.data
  }
  resumeOfferQuotation = async ({ offerId, ...data }) => {
    const response = await axios.put(`${this.resource}/${offerId}/resumeQuotation`, data)
    return response.data
  }
  restartOfferQuotation = async ({ offerId, ...data }) => {
    const response = await axios.put(`${this.resource}/${offerId}/restartQuotation`, data)
    return response.data
  }
  resumeOfferBooking = async ({ offerId, ...data }) => {
    const response = await axios.put(`${this.resource}/${offerId}/resumeBooking`, data)
    return response.data
  }
  restartOfferBooking = async ({ offerId, ...data }) => {
    const response = await axios.put(`${this.resource}/${offerId}/restartBooking`, data)
    return response.data
  }

  //Contributor
  contributorReview = async ({ offerId, remark, files }) => {
    const form = new FormData()
    form.append('remark', remark)

    for (const file of files) {
      form.append('file', file)
    }

    const response = await axios.put(`${this.resource}/${offerId}/contributorReview`, form)

    return response.data
  }

  contributorComment = async ({ offerId, remark, files }) => {
    const form = new FormData()
    form.append('remark', remark)

    for (const file of files) {
      form.append('file', file)
    }

    const response = await axios.put(`${this.resource}/${offerId}/contributorComment`, form)

    return response.data
  }

  //Quotation Approval

  approveOfferQuotation = async ({ offerId, approverLevel, approverType, files, remark }) => {
    const form = new FormData()
    form.append('remark', remark)

    for (const file of files) {
      form.append('file', file)
    }
    const response = await axios.put(
      `${this.resource}/${offerId}/approveQuotation?level=${approverLevel}&type=${approverType}`,
      form
    )

    return response.data
  }

  rejectOfferQuotation = async ({ offerId, approverLevel, approverType, files, remark }) => {
    const form = new FormData()
    form.append('remark', remark)

    for (const file of files) {
      form.append('file', file)
    }
    const response = await axios.put(
      `${this.resource}/${offerId}/rejectQuotation?level=${approverLevel}&type=${approverType}`,
      form
    )

    return response.data
  }
  //Booking

  approveOfferBooking = async ({ offerId, approverLevel, approverType, files, remark }) => {
    const form = new FormData()
    form.append('remark', remark)
    for (const file of files) {
      form.append('file', file)
    }
    const response = await axios.put(
      `${this.resource}/${offerId}/approveBooking?level=${approverLevel}&type=${approverType}`,
      form
    )

    return response.data
  }

  rejectOfferBooking = async ({ offerId, approverLevel, approverType, files, remark }) => {
    const form = new FormData()
    form.append('remark', remark)
    for (const file of files) {
      form.append('file', file)
    }
    const response = await axios.put(
      `${this.resource}/${offerId}/rejectBooking?level=${approverLevel}&type=${approverType}`,
      form
    )

    return response.data
  }

  //Approval Invitation

  batchApprove = async (data) => {
    const response = await axios.put(`${this.resource}/batchApprove`, data)

    return response.data
  }
}

export default OfferApprovalService
